var React = require('react');

function PlusCircle (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"#5B00DB","strokeWidth":"2","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round"},React.createElement("path",{"d":"M27.5 15c0 6.894-5.585 12.5-12.515 12.5C8.085 27.5 2.5 21.894 2.5 15S8.084 2.5 14.985 2.5C21.915 2.5 27.5 8.106 27.5 15zM8.301 14.737h13.398M15 8.038v13.398"})));
}

PlusCircle.defaultProps = {"width":"30","height":"30","viewBox":"0 0 30 30"};

module.exports = PlusCircle;

PlusCircle.default = PlusCircle;
